import { useMemo } from 'react';
import { handleRequestError, useRestClient } from '../useRestClient';
import { AppointmentDateDTO } from '@/data/DTOs/schedule/AppointmentDateDTO';
import { SCHEDULE_APPOINTMENT_DATE_URL } from '@/constants/constants';

export function useAvailableDatesService() {
  const { restClient } = useRestClient();

  const getAvailableDates = async (
    locationId?: string,
    yearMonth?: string,
    resourceId?: string
  ): Promise<AppointmentDateDTO[]> => {
    try {
      const params = {
        locationId,
        yearMonth: yearMonth ?? null,
        resourceId: resourceId ?? null,
      };

      const response = await restClient.get(
        `${SCHEDULE_APPOINTMENT_DATE_URL}`,
        {
          params: params,
        }
      );

      return response.data as AppointmentDateDTO[];
    } catch (error) {
      throw handleRequestError(error);
    }
  };

  return useMemo(() => ({ getAvailableDates }), []);
}
